import { cn } from '@/lib/ui/utils';
import type { HTMLAttributes } from 'react';

export type CmsPublicPageMode = 'standard' | 'workspace';

export function CmsPublicThemeRoot({
  className,
  mode,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  mode: CmsPublicPageMode;
}) {
  return (
    <div
      {...props}
      className={cn(
        'cms-theme min-h-screen bg-background text-on-surface',
        mode === 'workspace' ? 'cms-theme-workspace' : 'cms-theme-standard',
        className
      )}
      data-cms-page-mode={mode}
    />
  );
}
